import { useState, useEffect } from "react";
import { Table, Modal, Card, Spinner, Button, Form } from "react-bootstrap";
import axios from "axios";
import { useNavigate, useParams, Link } from "react-router-dom";
import logo from "../assets/logo1.png";
import jsPDF from "jspdf";
import "jspdf-autotable";
import './design/Ficha.css';
import fotodefault from '../assets/images.png'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faPenToSquare, faTrash, faIdCard } from "@fortawesome/free-solid-svg-icons";
import '../Components/design/Ficha.css';
import CarnetSocio from "./Carnet";
import { RoleGate } from "./middleware/RoleGate";

const FichaRut = () => {
  const { rut } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const MAX_FILE_SIZE_MB = 1;
  const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024; // Convertir MB a bytes
  const navigate = useNavigate();
  const [urlFoto, setUrlFoto] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showCarnet, setShowCarnet] = useState(false);

  const fetchNameById = async (endpoint, id) => {
    if (!id) return "Desconocido";
    try {
      const response = await axios.get(`https://socios.kolpingchile.cl/backend/api/${endpoint}/${id}`);
      return response.data.nombre || "Desconocido";
    } catch (error) {
      console.error(`Error al obtener ${endpoint} con ID ${id}:`, error);
      return "Desconocido";
    }
  };

  const formatDate = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);
    return date.toLocaleDateString("es-CL", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  const rutConGuion = (rut) => {
    if (!rut) return "";

    // Quitar puntos y guion
    let rutLimpio = rut.replace(/\./g, "").replace(/-/g, "");

    // Separar cuerpo y dígito verificador
    const cuerpo = rutLimpio.slice(0, -1);
    const dv = rutLimpio.slice(-1);

    // Formatear con puntos cada 3 dígitos (de derecha a izquierda)
    let cuerpoFormateado = "";
    let contador = 0;

    for (let i = cuerpo.length - 1; i >= 0; i--) {
      cuerpoFormateado = cuerpo[i] + cuerpoFormateado;
      contador++;
      if (contador % 3 === 0 && i !== 0) {
        cuerpoFormateado = "." + cuerpoFormateado;
      }
    }

    return `${cuerpoFormateado}-${dv.toUpperCase()}`; // Retornar con guion y DV en mayúscula
  };


  const generatePDF = () => {
    const doc = new jsPDF();
    doc.setFont("times", "normal");
    doc.setFontSize(16);
    doc.addImage(logo, "png", 15, 5, 50, 20);
    doc.text(`N° Socio: ${data.n_socio}`, 160, 20);
    doc.setFont("times", "bold");
    doc.setFontSize(16);
    doc.text("FICHA DE SOCIO", 85, 30);
    doc.addImage(urlFoto, "png", 150, 35, 40, 40);
    doc.setFont("times", "normal");
    doc.setFontSize(14);
    doc.text(`RUT: ${rutConGuion(data.rut)}`, 150, 80);


    doc.setFontSize(16);
    doc.setFont("times", "bold");
    doc.text("Datos Familia", 20, 40);
    doc.setFontSize(12);
    doc.setFont("times", "normal");
    doc.text(`Familia Kolping: `, 20, 50);
    doc.text(`${data.familia}`, 60, 50);
    doc.text(`Oficializado el: `, 20, 60);
    doc.text(`${data.fecha_oficializacion}`, 60, 60);
    doc.text(`Diócesis: `, 20, 70);
    doc.text(`${data.diocesis}`, 60, 70);
    doc.text(`Zona: `, 20, 80);
    doc.text(`${data.zona}`, 60, 80);

    doc.line(20, 90, 190, 90); // Línea horizontal

    doc.setFontSize(16);
    doc.setFont("times", "bold");
    doc.text("Datos Socio", 20, 100);
    doc.setFontSize(12);
    doc.setFont("times", "normal");
    // doc.text(`Apellidos: `, 20, 110);
    // doc.text(`${data.apellido}`, 70, 110);
    // doc.text(`Nombres: `, 20, 120);
    // doc.text(`${data.nombre}`, 70, 120);
    doc.text(`Nombre Completo: `, 20, 110);
    doc.text(`${data.nombre} ${data.apellido}`, 60, 110);
    doc.text(`Estado: `, 20, 120);
    doc.text(`${data.status}`, 60, 120);
    doc.text(`Domicilio: `, 20, 130);
    doc.text(`${data.direccion}`, 60, 130);
    doc.text(`Comuna: `, 20, 140);
    doc.text(`${data.comuna}, ${data.region}`, 60, 140);
    doc.text(`Fecha de Nacimiento: `, 20, 150);
    doc.text(`${data.fecha_nacimiento}`, 60, 150);
    doc.text(`Oficio o Profesión: `, 20, 160);
    doc.text(`${data.oficio}`, 60, 160);
    doc.text(`Correo Electrónico: `, 20, 170);
    doc.text(`${data.email}`, 60, 170);
    doc.text(`Número de Teléfono: `, 20, 180);
    doc.text(`${data.telefono}`, 60, 180);
    doc.text(`Fecha de ingreso a O. K. CH. el ${data.fecha_inicio_socio}`, 20, 200);


    doc.setFont("times", "italic");
    doc.text("\"El Socio se Compromete a vivir y respetar los altos y nobles ideales dejados por el Padre Adolfo Kolping, asumidos por la Obra Kolping Chile e Internacional.\"", 20, 250, { maxWidth: 170 });

    doc.save(`Ficha_Socio_${data.rut}.pdf`);
  };

  const handleDelete = async (rut) => {
    if (!window.confirm("¿Estás seguro de que deseas eliminar este socio?")) return;
    try {
      await axios.delete('https://socios.kolpingchile.cl/backend/api/socios', { data: { rut } });
      navigate("/mostrar");
    } catch (error) {
      console.error('Error al eliminar socio:', error.response?.data || error.message);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      alert("⚠️ El archivo debe ser una imagen");
      return;
    }

    if (file.size > MAX_FILE_SIZE_BYTES) {
      alert(`⚠️ La imagen no debe superar los ${MAX_FILE_SIZE_MB} MB`);
      return;
    }

    setSelectedFile(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleUpload = async () => {
    if (!selectedFile) return alert("Selecciona una imagen");

    const formData = new FormData();
    formData.append("rut", rut);
    formData.append("foto", selectedFile);

    try {
      const res = await axios.post("https://socios.kolpingchile.cl/backend/api/foto", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setMensaje(res.data.mensaje || "Foto subida correctamente");
      window.location.reload();
      setSelectedFile(null);
      setPreview(null);
    } catch (error) {
      console.error("❌ Error al subir imagen:", error.message);
      setMensaje("Error al subir imagen");
    }
  };
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  useEffect(() => {
    const fetchFoto = async () => {
      try {
        const fotoRes = await axios.get(`https://socios.kolpingchile.cl/backend/api/fotos/${rut}`);
        if (fotoRes.data?.imagen) {
          setUrlFoto(`${fotoRes.data.imagen}`);
        } else {
          setUrlFoto(null);
        }
      } catch (fotoError) {
        console.warn("Foto no encontrada o error:", fotoError.message);
        setUrlFoto(null);
      }
    };

    if (rut) {
      fetchFoto();
    }
  }, [rut]);


  useEffect(() => {
    if (!rut) return;

    setLoading(true);
    setError(null);

    const fetchData = async () => {
      try {
        const socioRes = await axios.get(`https://socios.kolpingchile.cl/backend/api/socios/${rut}`);
        const data = socioRes.data;
        const tipo_socio = await fetchNameById("tipos", data.tipo_socio);
        const zona = await fetchNameById("zonas", data.zona);
        const region = await fetchNameById("regiones", data.region);
        const comuna = await fetchNameById("comunas", data.comuna);
        const status = await fetchNameById("status", data.status);
        const diocesis = await fetchNameById("diocesis", data.diocesis);
        const familia = await fetchNameById("familias", data.familia);

        setData({
          ...data,
          fecha_nacimiento: formatDate(data.fecha_nacimiento),
          fecha_inicio_socio: formatDate(data.fecha_inicio_socio),
          fecha_oficializacion: formatDate(data.fecha_oficializacion),
          tipo_socio,
          zona,
          region,
          comuna,
          status,
          diocesis,
          familia
        });
      } catch (err) {
        setError("Socio no encontrado o error en la consulta.");
        console.error("Error al buscar socio", err);
        navigate("/mostrar");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [rut, navigate]);

  const handleOpenCarnet = () => {
    setShowCarnet(true);
  };

  if (loading) return <Spinner animation="border" />;
  if (error) return <p className="text-danger mt-3">{error}</p>;

  return (
    <div className="container mt-4">
      {data && (
        <Card className="mt-4">
          <div>
            <h2 className="mb-4">Ficha del Socio</h2>
          </div>
          <div className="d-grid justify-content-center mb-2">
            <div className="col" role="group" aria-label="Acciones Ficha">
              <Button variant="secondary" size="sm" onClick={handleOpenCarnet}><FontAwesomeIcon size="lg" icon={faIdCard} /> Carnet </Button>
              <Button variant="success" size="sm" onClick={generatePDF}><FontAwesomeIcon size="lg" icon={faFilePdf} /> Ficha </Button>
            </div>
            <RoleGate allowedRoles={["Administrador"]}>
              <div className="col mt-2" role="group" aria-label="Acciones Ficha">
                <Link className="btn btn-dark btn-sm me-2" title="Editar Socio" to={`/editar/${data.rut}`}>
                  <FontAwesomeIcon icon={faPenToSquare} size="lg" />
                </Link>
                <button className="btn btn-danger btn-sm" title="Eliminar Socio" onClick={() => handleDelete(data.rut)}><FontAwesomeIcon icon={faTrash} size="lg" /></button>
              </div>
            </RoleGate>
          </div>

          {showCarnet && <CarnetSocio socio={data} foto={urlFoto} />}
          {mensaje && <p className="mt-2 text-info">{mensaje}</p>}
          <div className="text-center">
            {/* Foto clickable */}
            <div
              style={{
                width: "150px",
                height: "150px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "20px auto",
                background: "#f8f9fa",
                cursor: "pointer",
              }}
              onClick={handleOpenModal} title="Elegir nueva foto"
            >
              {rut ? (
                <img
                  src={urlFoto || fotodefault}
                  alt="Foto socio"
                  style={{ maxWidth: "150px", border: "2px solid #ccc" }}
                />
              ) : (
                <p>Sin foto disponible</p>
              )}
            </div>

            {/* Modal para subir foto */}
            <RoleGate allowedRoles={["Administrador"]}>
              <Modal show={showModal} onHide={handleCloseModal} centered>
                <Modal.Header closeButton>
                  <Modal.Title>Subir foto</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form.Group controlId="formFile" className="mb-3">
                    <Form.Label>Seleccionar foto</Form.Label>
                    <Form.Control type="file" accept="image/*" onChange={handleFileChange} />
                  </Form.Group>
                  {preview && (
                    <div style={{ marginTop: "10px", textAlign: "center" }}>
                      <p>Vista previa:</p>
                      <img
                        src={preview}
                        alt="Vista previa"
                        style={{ maxWidth: "200px", border: "1px solid #ccc" }}
                      />
                    </div>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCloseModal}>
                    Cancelar
                  </Button>
                  <Button
                    variant="primary"
                    disabled={!selectedFile}
                    onClick={() => {
                      handleUpload();
                      handleCloseModal();
                    }}
                  >
                    Subir Foto
                  </Button>
                </Modal.Footer>
              </Modal>
            </RoleGate>
          </div>


          <Card.Body className="body">
            <Card.Title className="text-center" style={{ fontSize: "1.8rem", fontWeight: "bold" }}>
              {data.nombre} {data.apellido}
            </Card.Title>

            <Table striped bordered hover responsive size="sm" style={{ fontSize: "1rem", marginTop: "15px" }}>
              <tbody>
                <tr>
                  <td><strong>N° de socio</strong></td>
                  <td>{data.n_socio}</td>
                </tr>
                <tr>
                  <td><strong>RUT</strong></td>
                  <td>{rutConGuion(data.rut)}</td>
                </tr>
                <tr>
                  <td><strong>Teléfono</strong></td>
                  <td>{data.telefono}</td>
                </tr>
                <tr>
                  <td><strong>Email</strong></td>
                  <td>{data.email}</td>
                </tr>
                <tr>
                  <td><strong>Tipo Socio</strong></td>
                  <td>{data.tipo_socio}</td>
                </tr>
                <tr>
                  <td><strong>Zona</strong></td>
                  <td>{data.zona}</td>
                </tr>
                <tr>
                  <td><strong>Región</strong></td>
                  <td>{data.region}</td>
                </tr>
                <tr>
                  <td><strong>Comuna</strong></td>
                  <td>{data.comuna}</td>
                </tr>
                <tr>
                  <td><strong>Dirección</strong></td>
                  <td>{data.direccion}</td>
                </tr>
                <tr>
                  <td><strong>Fecha de Nacimiento</strong></td>
                  <td>{data.fecha_nacimiento}</td>
                </tr>
                <tr>
                  <td><strong>Fecha Inicio Socio</strong></td>
                  <td>{data.fecha_inicio_socio}</td>
                </tr>
                <tr>
                  <td><strong>Fecha de Oficialización</strong></td>
                  <td>{data.fecha_oficializacion}</td>
                </tr>
                <tr>
                  <td><strong>Oficio</strong></td>
                  <td>{data.oficio}</td>
                </tr>
                <tr>
                  <td><strong>Status</strong></td>
                  <td>{data.status}</td>
                </tr>
                <tr>
                  <td><strong>Diocesis</strong></td>
                  <td>{data.diocesis}</td>
                </tr>
                <tr>
                  <td><strong>Familia</strong></td>
                  <td>{data.familia}</td>
                </tr>
                <tr>
                  <td><strong>Notas</strong></td>
                  <td>{data.notas}</td>
                </tr>
              </tbody>

            </Table>
          </Card.Body>

        </Card>
      )}
    </div>
  );
};

export default FichaRut;
